export function transfersReducer(state = "",{
    type,
    payload
}){
    
    switch(type){
        case "NEW_TRANSFER":            
        case "UPDATE_TRANSFER":
            let list = Object.assign({}, state);
            list[payload.transfer_id] = payload
            
            return list
        case "GET_TRANSFERS":
            return payload
        case "DELETE_TRANSFER":            
            let list4 = Object.assign({}, state);
    
            delete list4[payload.transfer_id]
            return list4
             
        default:
            return state;
    }
    
}